<script setup>
// §8.7 WidgetShell — the locked shell all 14 Home widgets compose. It is a Card
// (surface + line, NO shadow, §4) with a titled header, an optional action link,
// and a body slot. Widgets never invent their own chrome — they fill this shell.
import LCard from '../surfaces/Card.vue'
import LCardHeader from '../surfaces/CardHeader.vue'

defineProps({
  title: { type: String, required: true },
  meta: { type: String, default: null },
})
</script>

<template>
  <LCard class="l-widget">
    <template #header>
      <LCardHeader :title="title" :meta="meta">
        <template v-if="$slots.chip" #chip><slot name="chip" /></template>
        <template v-if="$slots.action" #action><slot name="action" /></template>
      </LCardHeader>
    </template>
    <slot />
  </LCard>
</template>

<style scoped>
.l-widget {
  height: 100%;
}
</style>
